jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Browser - Keydown Focus Class
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $("body").on("keydown", function () {
        if (!$(".keyboard-in-use")[0]) {
            $(this).addClass("keyboard-in-use");
        }
    });

    $("body").on("mousedown", function () {
        if ($(".keyboard-in-use")[0]) {
            $(this).removeClass("keyboard-in-use");
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // _Leaving Site Modal
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    const link = $("a:not(.leave-site-modal__continue-button)");
    const siteDomain = window.location.host;
    const allowedHosts = [
        'mailchi.mp',
        window.location.host,
    ];

    link.on("mousedown", (event) => {
        var link     = event.currentTarget,
            linkHost = link.host,
            linkURL  = link.getAttribute("href");

        if (!allowedHosts.includes(linkHost)) {
            event.preventDefault();

            var button = $('#leave-site-message__modal').find('.m-centered-cta-block__button');

            button.attr('href', linkURL);

            $('#leave-site-message__modal').modal('handleOpen');

        }
    });

    link.on("keydown", (event) => {
        var link = event.currentTarget,
            linkHost = link.host,
            linkURL = link.getAttribute("href");

        if (!allowedHosts.includes(linkHost)) {
            event.preventDefault();

            var button = $('#leave-site-message__modal').find('.m-centered-cta-block__button');

            button.attr('href', linkURL);

            $('#leave-site-message__modal').modal('handleOpen');

        }
    }); 


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Ajax Add to Cart - WooCommerce
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    // $('.ajax-add-to-cart').on('click', function (e) {
    //     e.preventDefault();

    //     var productID   = $(this).data('product_id'),
    //         button      = $(this),
    //         productCard = $(this).closest('.m-product-thumbnail-card'),
    //         message     = productCard.find('.m-product-thumbnail-card__message');
 
    //     $.ajax({
    //         type: 'POST',
    //         url: AJAX.url, // Use the WordPress AJAX URL
    //         data: {
    //             action: 'add_to_cart',
    //             product_id: productID,
    //         },
    //         beforeSend: function () {
    //             productCard.addClass('ajax-loading');
    //         },
    //         success: function (result) {
    //             if (result.data.message){
    //                 productCard.append(result.data.message);

    //                 if (message) {
    //                     message.remove();
    //                 }

    //                 productCard.removeClass('ajax-loading');
    //                 $(window).trigger('ajax');
    //             }
    //         },
    //         error: function () {
    //             button.removeClass('loading');
    //             alert('Failed to add product to cart.');
    //         }
    //     }); 
    // });
}); 
